import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./Reveal";
import { sized } from "../lib/images";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "-10%"]);
  const overlay = useTransform(scrollYProgress, [0, 1], [0.6, 0.95]);

  return (
    <section
      ref={ref}
      className="relative overflow-hidden border-b border-white/5"
      data-testid="page-hero"
    >
      {image && (
        <>
          <motion.div style={{ y }} className="absolute inset-x-0 top-0 h-[115%] -z-[1]">
            <img
              src={sized(image, 1920)}
              alt=""
              className="h-full w-full object-cover object-center"
              decoding="async"
              draggable={false}
            />
          </motion.div>
          <motion.div
            style={{ opacity: overlay }}
            className="absolute inset-0 -z-[1] bg-black"
          />
          <div className="absolute inset-0 -z-[1] bg-gradient-to-b from-black/40 via-black/30 to-[#0A0A0A]" />
        </>
      )}

      <div className="mx-auto flex max-w-[1400px] flex-col justify-start px-6 pt-32 pb-20 md:px-12 md:pt-48 md:pb-32 lg:px-16">
        <Reveal>
          <div className="eyebrow">{eyebrow}</div>
        </Reveal>
        
        <Reveal delay={0.05}>
          {/* ALTERADO: max-w-5xl para max-w-none (ou max-w-7xl se quiseres um limite seguro) */}
          <h1 className="font-display mt-6 max-w-none text-5xl font-black uppercase leading-[0.95] tracking-tighter sm:text-7xl lg:text-8xl text-white">
            {title}
          </h1>
        </Reveal>

        {subtitle && (
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-3xl text-lg text-white/75 md:text-xl leading-relaxed">
              {subtitle}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}